export function toArray<T = unknown>(any: any): T[] {
  try {
    return Array.from(any) as any
  } catch (e) {
    return [] as any
  }
}
